import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getAdminTypeListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}admin-type${params.dropDownList}`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getAdminTypeListApi